const CSS_CLASSES = {
	ACTIONS: 'root__card__actions',
	CART: 'cart',
	CONTROL: 'form-control',
	INVALID: 'root--invalid',
	DATATABLE: 'datatable',
	POPUP_WARNING: 'popupWarning',
	POPUP_WARNING_CONTENT: 'popupWarningContent',
	WARNING_CLINICAL_CONTENT: 'warning__clinical__content',
	PAGE_HEADER: 'page__header',
	USER_NETWORK_ID: 'user__network__id',
};

export { CSS_CLASSES };
